module.exports = __webpack_public_path__ + "static/img/erweima.d200033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/erweima.jpg
// module id = npCm
// module chunks = 1